import { useNavigate, useParams } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { useEffect, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import moment from "moment";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { HandlePurchaseRequestStatus } from "../../../utility/CommonFunctions";
import ApproveRejectModal from "../../../components/comman/ApproveRejectModal";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import Logs from "../../Logs/Logs";
import DocumentIcon from "../../../components/Icons/DocumentIcon";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import MainHeading from "../../../components/comman/MainHeading";

export default function PurchaseRequestDetails() {
  let { id } = useParams();
  const userDetails = useSelector((state) => state.root.userDetails);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [purchaseReqData, setPurchaseReqData] = useState();
  const [modalType, setModalType] = useState("");
  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal(!modal);
  };
  const [docModal, setDocModal] = useState(false);
  const toggleDocModal = () => {
    setDocModal(!docModal);
  };
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [refreshLogs, setRefreshLogs] = useState(false);

  useEffect(() => {
    GetSupplyRequestDetail();
  }, [id]);

  const GetSupplyRequestDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_purchase_request_detail + `?purchaseRequestId=${id}`;
    callApi(API, options).then((response) => {
      setDataLoading(false);
      if (response?.status === true) {
        setPurchaseReqData(response?.data);
      }
    });
  };

  const handleReqStatus = (status, reason = "") => {
    let postData = {
      status: status,
      ...(status === "Rejected" && { rejectReason: reason }),
    };
    const option = {
      method: "POST",
      data: postData,
    };

    setIsLoading(true);
    callApi(
      apiUrl.update_purchase_request_status + `?purchaseRequestId=${id}`,
      option
    )
      .then((res) => {
        setIsLoading(false);
        if (res?.status === true) {
          toast.success(res?.message);
          GetSupplyRequestDetail();
          setRefreshLogs(true);
        } else {
          toast.error(res?.message);
        }
        toggle();
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
      });
  };

  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    toggleDocModal();
  };

  // console.log(purchaseReqData);

  return (
    <>
      <>
        {dataLoading && <BgBlurLoader />}
        <div className="content container-fluid">
          <MainHeading title="Purchase Request Detail" showBackButton={true} />

          <form action="">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12">
                        <ul
                          className={
                            dataLoading
                              ? "row list-unstyled mt-4 loading-skeleton"
                              : "row list-unstyled mt-4"
                          }
                        >
                          <li className="col-12 col-md-6 col-lg-4">
                            <p>
                              <span className="text-muted fs-5 d-block">
                                Request No. :-
                              </span>
                              {purchaseReqData?.requestNumber || "--"}
                            </p>
                          </li>
                          <li className="col-12 col-md-6 col-lg-4">
                            <p>
                              <span className="text-muted fs-5 d-block">
                                Request Type :-
                              </span>
                              <span
                                className={`${purchaseReqData?.type === "supplyRequest"
                                  ? "badge bg-blue-25 fw-normal rounded-pill"
                                  : "badge bg-grey-25 fw-normal rounded-pill"
                                  }`}
                              >
                                {purchaseReqData?.type === "supplyRequest"
                                  ? "Supply Request"
                                  : "Service Request" || "--"}
                              </span>
                            </p>
                          </li>
                          <li className="col-12 col-md-6 col-lg-4">
                            <p>
                              <span className="text-muted fs-5 d-block">
                                Status :-
                              </span>
                              {HandlePurchaseRequestStatus(
                                purchaseReqData?.status
                              )}
                            </p>
                          </li>
                          <li className="col-12 col-md-6 col-lg-4">
                            <p>
                              <span className="text-muted fs-5 d-block">
                                Site Name :-
                              </span>
                              {purchaseReqData?.site?.name || "--"}
                            </p>
                          </li>
                          <li className="col-12 col-md-6 col-lg-4">
                            <p>
                              <span className="text-muted fs-5 d-block">
                                Financial Year :-
                              </span>
                              {purchaseReqData?.financialYear || "--"}
                            </p>
                          </li>

                          <li className="col-12 col-md-6 col-lg-4">
                            <p>
                              <span className="text-muted fs-5 d-block">
                                Date :-
                              </span>
                              {purchaseReqData?.createdAt
                                ? moment(purchaseReqData?.createdAt)?.format(
                                  "DD-MM-YYYY"
                                )
                                : "--"}
                            </p>
                          </li>
                          <li className="col-12 col-md-6 col-lg-4">
                            <p>
                              <span className="text-muted fs-5 d-block">
                                Expected Date :-
                              </span>
                              {purchaseReqData?.expectedDate
                                ? moment(purchaseReqData?.expectedDate)?.format(
                                  "DD-MM-YYYY"
                                )
                                : "--"}
                            </p>
                          </li>
                          <li className="col-12 col-md-6 col-lg-4">
                            <p>
                              <span className="text-muted fs-5 d-block">
                                Created By :-
                              </span>
                              {purchaseReqData?.user?.name || "--"}{" "}
                              {purchaseReqData?.user?.designation?.name && (
                                <span className="text-muted fs-5">
                                  ({purchaseReqData?.user?.designation?.name})
                                </span>
                              )}
                            </p>
                          </li>
                          {purchaseReqData?.rejectReason && (
                            <li className="col-12 col-md-6 col-lg-4">
                              <p>
                                <span className="text-muted fs-5 d-block">
                                  Reject Reason :-
                                </span>
                                {purchaseReqData?.rejectReason || "--"}
                              </p>
                            </li>
                          )}
                        </ul>
                      </div>

                      {purchaseReqData?.purchaserequestexpenseheads &&
                        purchaseReqData?.purchaserequestexpenseheads?.length >
                        0 ? (
                        purchaseReqData?.purchaserequestexpenseheads?.map(
                          (item, index) => (
                            <div className="col-12" key={index}>
                              <div className="card-box mb-3">
                                <div className="row gap-3">
                                  <div className="col-12">
                                    <ul className="row list-unstyled mt-2">
                                      <li className="col-12 col-md-6 col-lg-4">
                                        <p>
                                          <span className="text-muted fs-5 d-block">
                                            {purchaseReqData?.type ==
                                              "supplyRequest"
                                              ? "Expense Head"
                                              : "Service Type"}{" "}
                                            :-
                                          </span>
                                          {item?.expensehead?.name || "--"}
                                        </p>
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="col-12 ">
                                    <div className="d-flex align-items-center justify-content-between border-bottom mb-4">
                                      <h4 className="fs-3 text-muted my-1 ">
                                        Material Details
                                      </h4>
                                    </div>
                                    <table className="table mt-3">
                                      <thead>
                                        <tr>
                                          <th className="text-start">Item Name</th>
                                          <th className="text-start">HSN Code</th>
                                          <th className="text-start">Unit</th>
                                          {purchaseReqData?.type == "serviceRequest" && <th className="text-start">Month</th>}
                                          <th className="text-start">Original Qty</th>
                                          <th className="text-start">Ordered Qty</th>
                                          <th className="text-start">Description</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {item?.supplyrequestitems?.length >
                                          0 ? (
                                          item?.supplyrequestitems?.map(
                                            (item2, index2) => (
                                              <tr key={index2}>
                                                <td className="text-start">
                                                  {item2?.item?.name || "--"}
                                                </td>
                                                <td className="text-start">
                                                  {item2?.item?.hsnCode || "--"}
                                                </td>
                                                <td className="text-start">
                                                  {item2?.item?.unit || "--"}
                                                </td>
                                                {purchaseReqData?.type == "serviceRequest" && <td className="text-start">
                                                  {item2?.month || "--"}
                                                </td>}
                                                <td className="text-start">
                                                  {item2?.quantity || "--"}
                                                </td>
                                                <td className="text-start">
                                                  {item2?.updatedQuantity || "--"}
                                                </td>
                                                <td className="text-start">
                                                  {item2?.itemDescription || item2?.description || "--"}
                                                </td>
                                              </tr>
                                            )
                                          )
                                        ) : (
                                          <tr className="">
                                            <td
                                              colSpan={purchaseReqData?.type == "serviceRequest" ? 7 : 6}
                                              className="text-center fw-bold"
                                            >
                                              No Data Found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        )
                      ) : (
                        <div>No Data Found</div>
                      )}
                    </div>

                    {(purchaseReqData?.canCreatePO && purchaseReqData?.status !== "PO Created") &&
                      userDetails?.designation?.canCreate?.includes("po") && (
                        <div className="d-flex align-items-center justify-content-end gap-3">
                          <button
                            onClick={() => {
                              setModalType("approve");
                              toggle();
                              navigate(RoutesLink?.create_purchase, {
                                state: {
                                  data: purchaseReqData,
                                  type: "Create",
                                },
                              });
                            }}
                            className="btn btn-outline-success fw-bold fs-5 py-3 px-5"
                            type="button"
                          >
                            Create PO
                          </button>
                        </div>
                      )}

                    {(purchaseReqData?.canChangeStatus && purchaseReqData?.status !== "PO Created") && (
                      <div className="d-flex align-items-center justify-content-end gap-3">
                        <button
                          onClick={() => {
                            setModalType("reject");
                            toggle();
                          }}
                          className="btn btn-danger px-5"
                          type="button"
                        >
                          Reject
                        </button>
                        <button
                          onClick={() => {
                            setModalType("approve");
                            toggle();
                          }}
                          className="btn btn-success px-5"
                          type="button"
                        >
                          Approve
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div className="row">
          <div className="col-12 ">
            <div className="card manage-user-list">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                  <h4 className="d-flex align-items-center mb-4">Documents</h4>
                </div>
                <ul className="row list-unstyled gap-3">
                  {purchaseReqData?.documents?.length > 0 ? (
                    purchaseReqData?.documents?.map((doc, index) => {
                      return (
                        <li key={doc.id || index} className="col-12">
                          <div
                            className="text-muted fs-5 d-flex align-items-center justify-content-between text-decoration-none w-100"
                            onClick={() => handleDocumentClick(doc)}
                            role="button"
                          >
                            <span className="d-flex align-items-center gap-2">
                              <DocumentIcon />
                              {doc?.name || "Document"}
                            </span>
                            <span className="fs-6">
                              {doc?.updatedAt ? moment(doc?.updatedAt).format("DD MMM YYYY | h:mm a") : ""}
                            </span>
                          </div>
                        </li>
                      );
                    })
                  ) : (
                    <div>No Document Found</div>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="form-group mb-3">
            <label htmlFor="totalLeavePerMonth" className="form-label">
              Description
            </label>
            <CKEditor
              editor={ClassicEditor}
              data={purchaseReqData?.description || ""}
              disabled={true}
              config={{
                toolbar: [],
                readOnly: true,
                image: {
                  toolbar: [
                    "imageStyle:alignLeft",
                    "imageStyle:alignCenter",
                    "imageStyle:alignRight",
                    "|",
                    "imageTextAlternative",
                  ],
                },
              }}
            />
          </div>
        </div>

        <Logs
          type={"purchaseRequest"}
          id={id}
          refreshLogs={refreshLogs}
          setRefreshLogs={setRefreshLogs}
        />
      </>
      <ViewDocumentModal
        modal={docModal}
        toggle={toggleDocModal}
        selectedDocument={selectedDocument}
      />
      <ApproveRejectModal
        modal={modal}
        toggle={toggle}
        submitHandler={(reason) =>
          handleReqStatus(
            modalType === "reject" ? "Rejected" : "Approved",
            reason
          )
        }
        isLoading={isLoading}
        actionType={modalType}
      />
    </>
  );
}
